<template>
  <div>
    <!-- ヘッダ -->
    <comVFHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="userName" :propMenuInfo2="companyName"></comVFHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <br/>
        <!-- 新規お申込みボタン -->
        <v-row>
          <v-col cols="7" class="d-flex align-end justify-start mt-4">
            <p class="text-h5">最新情報 [ {{searchStartDate}} ～ {{searchEndDate}} ] </p>
          </v-col>
          <v-col cols="5" class="d-flex justify-end mb-4" >
            <v-btn large color="light-green darken-1 white--text" rounded  elevation="20" :loading="loading" @click="latest()">
              <v-icon>mdi-cached</v-icon>{{ $t("LMT001") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :loading="datatableLoading" 
          loading-text="Loading... Please wait"
          class="v-dtbl-md-1 v-dtbl-head-md-1 elevation-1"
          :no-data-text="$t('webmsg.VFV100.datatblenodata')"
        >
          <template v-slot:[`item.displayValidityperiodEndDatetime`]="{ item }">
            <template v-if="item.expired">
              <span class="red--text"> {{ item.displayValidityperiodEndDatetime }}</span>
            </template>
            <template v-else>
              {{ item.displayValidityperiodEndDatetime }}
            </template>
          </template>
          <template v-slot:[`item.verifyStatusKbn`]="{ item }">
            <v-chip :color="item.verifyStatusKbn.color" text-color="white" >
              <v-icon left>{{ item.verifyStatusKbn.icon }}</v-icon>
                {{ item.verifyStatusKbn.name }}
            </v-chip>
          </template>
          <template v-slot:[`item.applied`]="{ item }">
            <template v-if="item.applied">
              <v-btn medium color="success" dark min-width="80px" elevation="5" @click="dispConfirmView(item.receiptNo, item.regTyp)">{{ $t("LCM005") }}</v-btn>
            </template>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
  </div>
</template>
<script>
import Constants from "../common/constantsVf";
import Utils from '../common/utils';
export default {
  name: "VFVerifyHome",
  data() {
    return {
      screenTitle: "確認ホーム",
      screenId: "VFV100",
      userName: "",
      companyName: "",
      loading: false,
      searchStartDate: "",
      searchEndDate: "",
      datatableLoading: false,
      verifyStatusKbnMstList: [],
      headers: [
          { text: 'NO', align: 'end', sortable: true, value: 'no', width: "6%"},
          { text: '受付番号', align: 'end', sortable: true, value: 'receiptNo', width: "10%" },
          { text: '受付日時', align: 'center', sortable: true, value: 'displayReceiptDatetime', width: "12%" },
          { text: '申請日時', align: 'center', sortable: true, value: 'displayAppDatetime', width: "12%" },
          { text: '期日', align: 'center', sortable: true, value: 'displayValidityperiodEndDatetime', width: "12%"},
          { text: '申請者名', align: 'start', sortable: true, value: 'appName', width: "" },
          { text: '確認状態', align: 'center', sortable: true, value: 'verifyStatusKbn', width: "10%"},
          { text: '詳細', align: 'center', sortable: false, value: 'applied', width: "10%" },
      ],
      desserts: [],
      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
          this.$router.push(this.$router.resolve({ name: 'VFA100'}).href);
        },
      },
    };
  },
  mounted() {
    this.addHandler();
  },
  created() {
    this.initialize();
  },
  methods: {
    addHandler: function () {
        window.addEventListener('popstate', this.browserHistoryBack);
    },
    removeHandler() {
        window.removeEventListener('popstate', this.browserHistoryBack);
    },
    browserHistoryBack() {
      this.$router.push(this.$router.resolve({ name: "VFV100" }).href);
    },
    /*
    * 初期表示
    */
    initialize: function() {
      
      this.getAppRequestList();
    },
    getAppRequestList: async function() {
      this.datatableLoading = true;
      // ログインサービス呼び出し
      let apiurl = Constants.URL_API_VFV100G01;
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        this.displyList(response.data);
        this.setStoreData(response.data);
        this.dispVerifyStatusKbnInfo();
      } catch(error) {
        if (this.$axios.isAxiosError(error) && error.response) {
          console.log(error.response.data);
        }
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['本人確認受付・申請一覧']);
        this.dlgMsgErr.isOpen = true;
        this.desserts.push({});
      } finally {
        this.datatableLoading = false;
      }
    },
    /*
    * 最新ボタン押下
    */
    latest: function() {
      this.getAppRequestList();
    },
    /**
     * 詳細画面遷移
     */
    dispConfirmView(receiptNo) {
      this.$router.push(this.$router.resolve({ name: "VFV210", params: {receiptNo: receiptNo, srcScreenId: this.screenId} }).href);
    },
    /*
    * 本人確認受付・申請一覧表示
    */
    displyList : function(responseData) {
      this.desserts = new Array();
      if (responseData == null) {
        return;
      }
      let searchResultList = responseData.data.verifyAppRequestList;
      if (Utils.isEmptyArry(searchResultList)) {
        return;
      }
      this.searchStartDate = responseData.data.searchStartDate;
      this.searchEndDate = responseData.data.searchEndDate;
      let request;
      for (const value of searchResultList) {
        request = {};
        request['no'] = value.no;
        request['receiptNo'] = value.receiptNo;
        request['displayReceiptDatetime'] = value.displayReceiptDatetime;
        request['displayAppDatetime'] = value.displayAppDatetime;
        request['displayValidityperiodEndDatetime'] = value.displayValidityperiodEndDatetime;
        request['appName'] = value.appName; 
        request['verifyStatusKbn'] = {cd: value.verifyStatusKbn, name: value.verifyStatusKbnName};
        request['applied'] = value.applied;
        request['expired'] = value.expired;
        this.desserts.push(request);
      }
    },
    setStoreData: function(responseDto) {
      this.$store.dispatch("vfMaster/setVerifyStatusKbnList", responseDto.data.verifyStatusKbnList);
      this.$store.dispatch("vfMaster/setVerifyDealKbnList", responseDto.data.dealWithKbnList);
      this.$store.dispatch("vfMaster/setAppDocKbnList", responseDto.data.appDocKbnList);
      this.$store.dispatch("vfMaster/setDocDetailKbnList", responseDto.data.docDetailKbnList);
      this.setAuthUserInfo(responseDto);
    },
    /*
    * 認証情報設定
    */
    setAuthUserInfo : function(responseData) {
      let loginUserInfo = responseData.data.loginUserInfo;
      this.$store.dispatch("vfAuthcUser/setLoggedUserInfo", {systemId: loginUserInfo.systemId, id: loginUserInfo.id, name:loginUserInfo.name, companyName:loginUserInfo.companyName, approverFlg:loginUserInfo.Approverflg});
      this.userName = loginUserInfo.name;
      this.companyName = loginUserInfo.companyName;
    },
    dispVerifyStatusKbnInfo : function() {
      this.verifyStatusKbnMstList = this.$store.getters["vfMaster/getVerifyStatusKbnList"];
      if (this.desserts == null || this.verifyStatusKbnMstList == null) {
          return;
      }
      this.desserts.forEach((dessert, index, arr) => {
        if (dessert.verifyStatusKbn.cd != null && dessert.verifyStatusKbn.cd != '') {
          let verifyStatus = this.getVerifyStatusNm(dessert.verifyStatusKbn.cd);
          if (verifyStatus != null) {
            arr[index].verifyStatusKbn.name = verifyStatus.nameAbbr;
            arr[index].verifyStatusKbn.color = verifyStatus.value2;
            arr[index].verifyStatusKbn.icon = verifyStatus.value3;
          }
        }
      });
    },
    getVerifyStatusNm(verifyStatusCd) {
      let retVal = "";
      let searchArry = "";
      if (verifyStatusCd != "") {
        searchArry = this.verifyStatusKbnMstList.find((v) => v.value1 === verifyStatusCd);
      }
      if (searchArry != null) {
        retVal = searchArry;
      }
      return retVal;
    },
  },
}
</script>
<style scoped>

</style>